import PiInstance from './Pi.instance';

export const getPartnerInfo = ({ companyGuid }: { companyGuid: string }) =>
  PiInstance.instance.get(`/core/api/v4/companies/${companyGuid}/companysettings/partnerinfo`);
